/**
 * Generate a unique ID using crypto.randomUUID()
 * Falls back to a timestamp + random string for older browsers
 */
export const uid = () =>
  typeof crypto !== 'undefined' && crypto.randomUUID
    ? crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
